import { Box, Button, Flex } from '@cowsquare/design';
import { Link } from 'gatsby';
import React from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';

const Title = styled.h2`
  margin: 0;
`;

const Description = styled.p`
  margin: 0;
  color: rgba(0, 0, 0, 0.4);
  text-align: center;
`;

const StyledLink = styled(Link)`
  text-decoration: none;
`;

const Thankyou = () => {
  return (
    <Flex justifyContent="center" alignItems="center" flexDirection="column">
      <Helmet>
        <title>Thank you - HKDU Public</title>
      </Helmet>
      <Box mt="50px">
        <Title>Thank You!</Title>
      </Box>
      <Box mt="10px">
        <Description>We have sent a comfirmation email to you, please check your inbox.</Description>
      </Box>
      <Box mt="20px">
        <Button variant="primary" as={StyledLink} to="/public">
          Back to Home
        </Button>
      </Box>
    </Flex>
  );
};

export default Thankyou;
